<template>
  <div class="page">
    <div class="breadcrumb">
      <router-link to="/home">上海盛目实业集团有限公司</router-link>
      <span>></span>
      <router-link to="/news">新闻中心</router-link>
    </div>
    <div class="main-news">
      <div class="main-news-left">
        <img :src="tNew.journalismUrl" alt="">
      </div>
      <div class="main-news-right">
        <div class="content">
          <div class="content-title-two">
            <p>{{tNew.journalismTitle}}</p>
          </div>
          <div class="content-txt">
            <p class="one" v-html="tNew.journalismAbstract"></p>
            <p class="two">{{handleTime(tNew.releaseTime)}}</p>
          </div>
        </div>
        <div class="desc">
          <router-link :to="`/news-info?id=${tNew.id}`">查看详情+</router-link>
        </div>
      </div>
    </div>
    <div class="list">
      <div class="list-item" v-for="i in newsList.slice(1)" :key="i.id">
        <router-link :to="`/news-info?id=${i.id}`">
          <div class="list-item-top">
            <img :src="i.journalismUrl" alt="">
          </div>
          <div class="list-item-bottom">
            <div class="title">
              <p>{{i.journalismTitle}}</p>
            </div>
            <div class="date">
              <p>{{handleTime(i.releaseTime)}}</p>
            </div>
          </div>
        </router-link>
      </div>
      <div class="list-item"></div>
    </div>
    <div class="pagination">
      <el-pagination background prev-text="上一页" next-text="下一页" layout="prev, pager, next" @current-change="currentPage" :page-size="size" :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { pressCenterAllPage } from '@/api/api'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      page: 1,
      size: 4,
      total: 0,
      newsList: []
    }
  },
  created() {
    this.getNewsList()
  },
  computed: {
    ...mapGetters(['pressnews']),
    tNew() {
      return this.newsList[0]
    }
  },
  methods: {
    currentPage(e) {
      this.page = e
      this.getNewsList()
    },
    getNewsList() {
      pressCenterAllPage({
        page: this.page,
        size: this.size
      }).then(res => {
        this.total = res.total
        this.newsList = res.records
      })
    },
    handleTime(time) {
      return this.$moment(time).format('YYYY-MM-DD')
    }
  }
}
</script>

<style lang="scss" scoped>
$page-center: 1200px;
.page {
  width: $page-center;
  margin: auto;
  img {
    width: 100%;
  }
  .breadcrumb {
    margin: 30px auto 40px;
  }
  .main-news {
    display: flex;
    height: 488px;
    overflow: hidden;
    margin-bottom: 70px;
    &-left {
      width: 65%;
      img {
        height: 100%;
      }
    }
    &-right {
      width: 35%;
      height: 100%;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      background-color: #f5f5f5;
      padding-top: 70px;
      .content {
        width: 80%;
        margin: auto;
        &-title-one {
          font-size: 14px;
          color: #1c3c8a;
          font-weight: 700;
          margin-bottom: 20px;
        }
        &-title-two {
          font-weight: 700;
          letter-spacing: 2px;
          margin-bottom: 30px;
        }
        &-txt {
          color: #333;
          line-height: 25px;
          .one {
            text-indent: 2em;
            display: -webkit-box;
            overflow: hidden;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 5;
            margin-bottom: 30px;
          }
          .two {
            text-align: right;
          }
        }
      }
      .desc {
        text-align: right;
        margin-right: 10px;
        margin-bottom: 10px;
      }
    }
  }
  .list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 50px;
    a {
      text-decoration: none;
    }
    &-item {
      width: 32%;
      margin-bottom: 15px;
      transition: all 300ms;
      cursor: pointer;
      &-top {
        height: 242px;
        img {
          height: 100%;
        }
      }
      &-bottom {
        height: 71px;
        background-color: #f5f5f5;
        padding: 3px 8px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        .title {
          display: -webkit-box;
          overflow: hidden;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          line-height: 23px;
          margin-bottom: auto;
          color: #000;
        }
        .date {
          font-size: 14px;
          text-align: right;
          color: #333;
          letter-spacing: 1px;
        }
      }
    }
    &-item:hover {
      transform: scale(1.02);
    }
  }
  ::v-deep .pagination {
    text-align: center;
    margin-bottom: 60px;
    .btn-prev,
    .btn-next {
      padding: 0 15px;
    }
  }
}
</style>
